import { render, staticRenderFns } from "./commodityClassificationManage.vue?vue&type=template&id=686d1c50&scoped=true"
import script from "./commodityClassificationManage.vue?vue&type=script&lang=js"
export * from "./commodityClassificationManage.vue?vue&type=script&lang=js"
import style0 from "./commodityClassificationManage.vue?vue&type=style&index=0&id=686d1c50&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686d1c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('686d1c50')) {
      api.createRecord('686d1c50', component.options)
    } else {
      api.reload('686d1c50', component.options)
    }
    module.hot.accept("./commodityClassificationManage.vue?vue&type=template&id=686d1c50&scoped=true", function () {
      api.rerender('686d1c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/mall/commodityClassificationManage.vue"
export default component.exports